import {
  ELEC_EMISSION_FACTOR_MT_PER_KWH,
  GAS_EMISSION_FACTOR_MT_PER_THERM,
} from './bhSourceControls';

export const EXPERIMENTAL_ELEC_EMISSION_FACTOR_MT_PER_KWH = ELEC_EMISSION_FACTOR_MT_PER_KWH;
export const EXPERIMENTAL_GAS_EMISSION_FACTOR_MT_PER_THERM = GAS_EMISSION_FACTOR_MT_PER_THERM;

/** Shown in tooltips / reconciliation — end-use activity only; T&D not embedded in kWh activity. */
export const EXPERIMENTAL_ELECTRICITY_EMISSION_TOOLTIP =
  'Experimental direct electricity emissions: end-use kWh × 0.000240 MT CO2e/kWh. Activity is end-use kWh; transmission and distribution losses are not included in this activity series. 2019 SCE/CPA mix uses a single effective factor (experimental).';

export const EXPERIMENTAL_GAS_EMISSION_TOOLTIP =
  'Experimental gas emissions: therms × 0.005313 MT CO2e/therm (CAP-derived common factor; experimental).';

export function experimentalEmissionFactorLabel(fuel: 'electricity' | 'natural_gas'): string {
  return fuel === 'electricity'
    ? `${EXPERIMENTAL_ELEC_EMISSION_FACTOR_MT_PER_KWH} MT CO2e per kWh (end-use)`
    : `${EXPERIMENTAL_GAS_EMISSION_FACTOR_MT_PER_THERM} MT CO2e per therm`;
}
